// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share-prompt-backdrop {
  position: fixed;
  inset: 0;
  z-index: 2060;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  animation: share-prompt-fade-in 0.2s ease;
}

@keyframes share-prompt-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.share-prompt-card {
  background: var(--color-bg-canvas-surface, #fff);
  border-radius: 6px;
  padding: 28px 32px 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  animation: share-prompt-slide-up 0.25s ease;
}

@keyframes share-prompt-slide-up {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}

.share-prompt-header {
  text-align: center;
  margin-bottom: 20px;
}

.share-prompt-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-primary, #0b0c0f);
  margin: 0 0 8px;
}

.share-prompt-header p {
  font-size: 14px;
  color: var(--color-text-secondary, rgba(11, 12, 15, 0.72));
  margin: 0;
  line-height: 1.5;
}

.share-prompt-link-box {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.share-prompt-link-input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 13px;
  border: 1px solid var(--color-border-input, #cfd3d8);
  border-radius: 4px;
  background: var(--color-bg-input, #ededed);
  color: var(--color-text-primary, #0b0c0f);
  font-family: monospace;
  cursor: text;
}

.share-prompt-copy-btn {
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  background: var(--color-text-primary, #0b0c0f);
  color: var(--color-bg-canvas-surface, #fff);
  cursor: pointer;
  white-space: nowrap;
  min-width: 72px;
}

.share-prompt-email-form {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.share-prompt-email-form input {
  flex: 1 1;
  padding: 10px 12px;
  font-size: 13px;
  border: 1px solid var(--color-border-input, #cfd3d8);
  border-radius: 4px;
  background: var(--color-bg-input, #ededed);
  color: var(--color-text-primary, #0b0c0f);
  font-family: inherit;
}

.share-prompt-email-form input:focus {
  outline: none;
  border-color: var(--color-accent-base, #c07b42);
}

.share-prompt-email-form button {
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid var(--color-border-input, #cfd3d8);
  border-radius: 4px;
  background: var(--color-bg-canvas-surface, #fff);
  color: var(--color-text-primary, #0b0c0f);
  cursor: pointer;
  white-space: nowrap;
}

.share-prompt-email-form button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.share-prompt-message {
  font-size: 13px;
  text-align: center;
  padding: 6px;
  border-radius: 4px;
  margin-bottom: 8px;
}

.share-prompt-message--success {
  color: #15803d;
  background: rgba(21, 128, 61, 0.08);
}

.share-prompt-message--error {
  color: #b91c1c;
  background: rgba(185, 28, 28, 0.08);
}

.share-prompt-dismiss {
  display: block;
  margin: 12px auto 0;
  background: none;
  border: none;
  color: var(--color-text-secondary, rgba(11, 12, 15, 0.5));
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
}

.share-prompt-dismiss:hover {
  color: var(--color-text-primary, #0b0c0f);
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferralSharePrompt.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,gDAAgD;EAChD,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yDAAyD;EACzD,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[".share-prompt-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 2060;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.45);\n  animation: share-prompt-fade-in 0.2s ease;\n}\n\n@keyframes share-prompt-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.share-prompt-card {\n  background: var(--color-bg-canvas-surface, #fff);\n  border-radius: 6px;\n  padding: 28px 32px 24px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  animation: share-prompt-slide-up 0.25s ease;\n}\n\n@keyframes share-prompt-slide-up {\n  from { opacity: 0; transform: translateY(12px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.share-prompt-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.share-prompt-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-primary, #0b0c0f);\n  margin: 0 0 8px;\n}\n\n.share-prompt-header p {\n  font-size: 14px;\n  color: var(--color-text-secondary, rgba(11, 12, 15, 0.72));\n  margin: 0;\n  line-height: 1.5;\n}\n\n.share-prompt-link-box {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.share-prompt-link-input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid var(--color-border-input, #cfd3d8);\n  border-radius: 4px;\n  background: var(--color-bg-input, #ededed);\n  color: var(--color-text-primary, #0b0c0f);\n  font-family: monospace;\n  cursor: text;\n}\n\n.share-prompt-copy-btn {\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  border-radius: 4px;\n  background: var(--color-text-primary, #0b0c0f);\n  color: var(--color-bg-canvas-surface, #fff);\n  cursor: pointer;\n  white-space: nowrap;\n  min-width: 72px;\n}\n\n.share-prompt-email-form {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.share-prompt-email-form input {\n  flex: 1;\n  padding: 10px 12px;\n  font-size: 13px;\n  border: 1px solid var(--color-border-input, #cfd3d8);\n  border-radius: 4px;\n  background: var(--color-bg-input, #ededed);\n  color: var(--color-text-primary, #0b0c0f);\n  font-family: inherit;\n}\n\n.share-prompt-email-form input:focus {\n  outline: none;\n  border-color: var(--color-accent-base, #c07b42);\n}\n\n.share-prompt-email-form button {\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid var(--color-border-input, #cfd3d8);\n  border-radius: 4px;\n  background: var(--color-bg-canvas-surface, #fff);\n  color: var(--color-text-primary, #0b0c0f);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.share-prompt-email-form button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.share-prompt-message {\n  font-size: 13px;\n  text-align: center;\n  padding: 6px;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.share-prompt-message--success {\n  color: #15803d;\n  background: rgba(21, 128, 61, 0.08);\n}\n\n.share-prompt-message--error {\n  color: #b91c1c;\n  background: rgba(185, 28, 28, 0.08);\n}\n\n.share-prompt-dismiss {\n  display: block;\n  margin: 12px auto 0;\n  background: none;\n  border: none;\n  color: var(--color-text-secondary, rgba(11, 12, 15, 0.5));\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 8px;\n}\n\n.share-prompt-dismiss:hover {\n  color: var(--color-text-primary, #0b0c0f);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
